export default __webpack_public_path__ + "static/media/Aleksić.b58de4cf.png";